import queryString from "query-string";

// TODO: We should be able to use React Router's useSearchParams hook
// https://reactrouter.com/en/main/hooks/use-search-params

export function userSkippedTransactionTypePicker(location) {
  return queryString.parse(location.search).transaction != null;
}

export function parseTransactionType(location) {
  const qs = queryString.parse(location.search);
  if (qs.transaction) {
    const lower = qs.transaction.toLowerCase();
    if (lower === "selling") {
      return "Selling";
    }
    if (lower === "buying") {
      return "Buying";
    }
    if (lower === "buyingandselling") {
      return "BuyingAndSelling";
    }
  }
  return null;
}

// FIXME: update this to take a passed-in location from React router instead of
// directly accessing window.location
export function parseTenure() {
  const qs = queryString.parse(window.location.search);
  if (qs.tenure) {
    const lower = qs.tenure.toLowerCase();
    if (lower === "freehold") {
      return "freehold";
    }
    if (lower === "leasehold") {
      return "leasehold";
    }
    if (lower === "leasehold with share of freehold") {
      return "leasehold with share of freehold";
    }
  }
  return null;
}

// Campaign attribution parameters that paid-search landing pages (e.g.
// www.juno.legal/start/) append to quote links. Only these are captured;
// everything else in the query string (transaction, tenure, fbclid, ...) is ignored.
const CLICK_ID_KEYS = ["gclid", "gclsrc", "gbraid", "wbraid"];
const UTM_KEY_PATTERN = /^utm_[a-z0-9_]{1,60}$/;
// Google click IDs are around 100 chars; utm values are normally a few words.
// The cap stops a hostile URL bloating the stored value.
const MAX_CAMPAIGN_VALUE_LENGTH = 500;

function isCampaignParamKey(key) {
  return UTM_KEY_PATTERN.test(key) || CLICK_ID_KEYS.includes(key);
}

// Returns an object of the campaign params found in the location's query
// string ({ utm_source: "google", gclid: "abc" }), or null when there are none.
// Keys must be lower-case, as Google sends them; a repeated key keeps its
// first value; blank values are dropped.
export function parseCampaignParams(location) {
  const qs = queryString.parse(location?.search ?? "");
  const params = {};
  Object.keys(qs).forEach((key) => {
    if (!isCampaignParamKey(key)) return;
    const rawValue = Array.isArray(qs[key]) ? qs[key][0] : qs[key];
    if (typeof rawValue !== "string") return;
    const value = rawValue.trim();
    if (value === "") return;
    params[key] = value.slice(0, MAX_CAMPAIGN_VALUE_LENGTH);
  });
  return Object.keys(params).length > 0 ? params : null;
}
